import api from "~/services/apis/antecipeApi";
import { blobToJson, filenameFromDisposition, saveBlob } from "~/utils/download";

export const getAdvanceRequests = async (limitParams, filtersParams) => {
  return api.get(
    `antecipebackoffice/advancepayment?limit=${limitParams.limit}&offset=${limitParams.offset}`,
    { params: filtersParams }
    // + `?startDate=${startDate}&endDate=${endDate}&crm=${crm}&crmUf=${crmuf}`
  );
};

export const updateDatePayment = (id, date) => {

  if(id && date){
    return api.patch(`antecipebackoffice/advancepayment/${id}`, { date: date })
  }else {
    throw new Error(`Id ou data inválida. ID: ${id} | Date: ${date}`)
  }

}

// Pacote já fora da empresa (aguardando contrato/assinatura) com plantão sem data de pagamento normal.
export const updateNormalPaymentDate = (packageId, vacancyAdvanceId, date) =>
  api.patch(`antecipebackoffice/advancepayment/${packageId}/vacancyadvance/${vacancyAdvanceId}/normal-payment-date`, { date });

const CONTRACT_MESSAGES = {
  "Doctor without Data Banks": "Verifique se você cadastrou os dados bancarios do médico!",
  "Doctor without Data Company": "Verifique se você cadastrou os dados da pessoa jurídica do médico!",
};

// CA15: POST explícito (gera, marca contract_generated_at e audita no BE). Nada de GET/window.open.
export const downloadContract = async (id, type) => {
  if (!id) throw new Error(`Id invalido: ${id}`);
  // O BE valida contra o enum ContractType ("PF" | "PJ"), sensível a maiúsculas.
  const contractType = String(type || "").toUpperCase();
  let response;
  try {
    response = await api.post(`antecipebackoffice/advancepayment/${id}/contract`, { contractType }, { responseType: "blob" });
  } catch (e) {
    const status = e?.response?.status;
    const body = await blobToJson(e?.response?.data);
    const known = CONTRACT_MESSAGES[body?.message];
    const error = new Error(
      known || (status === 403 ? "Seu acesso não permite gerar contratos." : "Ocorreu um erro interno do sistema, entre em contato com o suporte!")
    );
    error.name = known ? "without-data" : "internal-error";
    error.status = status;
    throw error;
  }
  saveBlob(response.data, filenameFromDisposition(response.headers?.["content-disposition"], `contrato-${id}-${contractType}.pdf`));
};

// Janelas (c) e (d): `extra` leva `sla`/`friction` no mesmo PATCH (contrato BE-1b).
export const updateStatus = async (id, status, extra = {}) => {
  if (!status || !id) throw new Error(`Status ou ID invalido: status: ${status} | id: ${id}`);
  return api.patch(`antecipebackoffice/advancepayment/${id}/status`, { status, ...extra });
};

// Janela (a): sem `body` o PATCH vai sem corpo, como antes (BE com a captura desligada).
export const cancel = async (id, body) => {
  if (!id) throw new Error(`ID invalido: ${id}`);
  return api.patch(`antecipebackoffice/advancepayment/${id}/cancel`, body);
};
